
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.022 2.293a3.25 3.25 0 11.471 6.457H5a.75.75 0 110-1.5h8.514a1.75 1.75 0 10-1.638-2.268.75.75 0 11-1.432-.444 3.25 3.25 0 012.578-2.245zm6.418 10.7a1.75 1.75 0 00-.926-.243H3a.75.75 0 010-1.5h15.493a3.25 3.25 0 11-3.05 4.212.75.75 0 111.433-.444 1.751 1.751 0 102.564-2.024zM9.514 16.75a1.75 1.75 0 11-1.638 2.268.75.75 0 00-1.432.444 3.25 3.25 0 103.05-4.212H4a.75.75 0 000 1.5h5.514z"}})])
          )
        }
      }
    